<template>
  <l-section class="cases-grid" v-editable="blok">
    <l-container class="cases-grid__grid">
      <h-slug
        class="cases-grid__case"
        v-for="_case in filteredCases"
        :key="_case.full_slug"
        :to="{ linktype: 'story', cached_url: `/${_case.full_slug}` }"
      >
        <!-- <pre>{{ _case }}</pre> -->
        <div class="cases-grid__case-image-wrap">
          <h-picture
            v-if="_case.content.featured_image"
            class="cases-grid__case-image"
            :source="_case.content.featured_image.filename"
            ratio="1/1"
            :alt="_case.content.featured_image.alt"
            sizes="(min-width: 1000px) 33vw, (min-width: 600px) 33vw, calc(100vw)"
            loading="lazy"
          />
        </div>
        <a-header tag="h3" classes="h6" class="cases-grid__case-title fw-bold">
          {{ _case.name }}
        </a-header>
      </h-slug>
    </l-container>
  </l-section>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  blok: {
    type: Object,
    default: () => ({}),
  },
});

// Filter out cases that are only accessible via direct link
const filteredCases = computed(() => {
  if (!props.blok.cases) return [];
  return props.blok.cases.filter((_case) => !_case.accessible_only_via_link);
});
</script>

<style lang="scss" scoped>
.cases-grid {
  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 4rem;
  }
  &__case {
    display: flex;
    flex: 1 0 0;
    flex-direction: column;
    @media (hover: hover) {
      &:hover {
        .cases-grid__case-image {
          transform: scale(1.05);
        }
      }
    }
  }
  &__case-image-wrap {
    overflow: hidden;
  }
  &__case-image {
    transition: transform 0.5s var(--ease-in-out-cubic);
  }
  &__case-title {
    margin-top: 1rem;
  }
}
</style>
